import { Country } from '../enums/locale-country.enum';
import { ApplicationNames } from './shared-application.constants';
import { WebUserDataConstants } from './web-user-data.constants';

export class WebUserDataAppConfig {

	// We use the APPLICATION_NAME injection token to identify app origin and tag newly created portfolios
	public static readonly APPLICATION_NAMES_PORTFOLIO_SAVING = {
		[ApplicationNames.PORTFOLIO_ANALYSER]: {
			origin: WebUserDataConstants.APPLICATIONS.BFA_MODELS,
			toolOrigin: WebUserDataConstants.APPLICATIONS.BFA_PE,
			defaultApplication: WebUserDataConstants.APPLICATIONS.BFA,
			country: Country.en_US,
			applyPermsRC: 'bfa-new-data'
		},
		[ApplicationNames.SCENARIO_TESTER]: {
			origin: WebUserDataConstants.APPLICATIONS.BFA_ST,
			toolOrigin: WebUserDataConstants.APPLICATIONS.BFA_PE,
			defaultApplication: WebUserDataConstants.APPLICATIONS.BFA,
			country: Country.en_US,
			applyPermsRC: 'bfa-new-data'
		},
		[ApplicationNames.MY_SAVED_PORTFOLIOS]: {
			origin: WebUserDataConstants.APPLICATIONS.BFA_LIBRARY,
			toolOrigin: WebUserDataConstants.APPLICATIONS.BFA_PE,
			defaultApplication: WebUserDataConstants.APPLICATIONS.BFA,
			country: Country.en_US,
			applyPermsRC: 'bfa-new-data'
		},
		[ApplicationNames.TAX_ESTIMATOR]: {
			origin: WebUserDataConstants.APPLICATIONS.BFA_TAX,
			toolOrigin: WebUserDataConstants.APPLICATIONS.BFA_PE,
			defaultApplication: WebUserDataConstants.APPLICATIONS.BFA,
			country: Country.en_US,
			applyPermsRC: 'bfa-new-data'
		},
		[ApplicationNames.DASHBOARD]: {
			origin: WebUserDataConstants.APPLICATIONS.BFA_DASH,
			toolOrigin: WebUserDataConstants.APPLICATIONS.BFA_PE,
			defaultApplication: WebUserDataConstants.APPLICATIONS.BFA,
			country: Country.en_US,
			applyPermsRC: 'bfa-new-data'
		},
		[ApplicationNames.CMA_ESTIMATOR]: {
			origin: WebUserDataConstants.APPLICATIONS.BFA_CMA,
			toolOrigin: WebUserDataConstants.APPLICATIONS.BFA_PE,
			defaultApplication: WebUserDataConstants.APPLICATIONS.BFA,
			country: Country.en_US,
			applyPermsRC: 'bfa-new-data'
		},
		[ApplicationNames.INVESTMENT_QUALITY]: {
			origin: WebUserDataConstants.APPLICATIONS.BFA_IQ,
			toolOrigin: WebUserDataConstants.APPLICATIONS.BFA_PE,
			defaultApplication: WebUserDataConstants.APPLICATIONS.BFA,
			country: Country.en_US,
			applyPermsRC: 'bfa-new-data'
		},
		[ApplicationNames.PROFESSIONAL_INVESTORS]: {
			origin: WebUserDataConstants.APPLICATIONS.BFA_PI,
			toolOrigin: WebUserDataConstants.APPLICATIONS.BFA_PE,
			defaultApplication: WebUserDataConstants.APPLICATIONS.BFA,
			country: Country.en_US,
			applyPermsRC: 'bfa-new-data'
		},
		[ApplicationNames.PORTFOLIO_ANALYSIS_CONSTRUCTION]: {
			origin: WebUserDataConstants.APPLICATIONS.BPAS_PAC,
			toolOrigin: WebUserDataConstants.APPLICATIONS.BPAS_PE,
			defaultApplication: WebUserDataConstants.APPLICATIONS.BPAS,
			applyPermsRC: 'portfolio-centre:new-data'
		},
		[ApplicationNames.PORTFOLIO_CENTRE]: {
			origin: WebUserDataConstants.APPLICATIONS.NILE_PC,
			toolOrigin: WebUserDataConstants.APPLICATIONS.NILE_PE,
			defaultApplication: WebUserDataConstants.APPLICATIONS.NILE,
			applyPermsRC: 'portfolio-centre:new-data'
		},
		[ApplicationNames.PORTFOLIO_CENTRE_360]: {
			origin: WebUserDataConstants.APPLICATIONS.NILE_PC,
			toolOrigin: WebUserDataConstants.APPLICATIONS.NILE_PE,
			defaultApplication: WebUserDataConstants.APPLICATIONS.NILE,
			applyPermsRC: 'portfolio-centre:new-data'
		},
		[ApplicationNames.AC_PORTFOLIO_LIBRARY]: {
			origin: WebUserDataConstants.APPLICATIONS.BFA_LIBRARY,
			toolOrigin: WebUserDataConstants.APPLICATIONS.BFA_PE,
			defaultApplication: WebUserDataConstants.APPLICATIONS.BFA,
			country: Country.en_US,
			applyPermsRC: 'bfa-new-data'
		}
	};
}
